import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';

function MenuOptions({sImage, sTitle, sBody, sLink, sLinkLable}) {
  return (
    <Card style={{ width: '18rem' }}>
      <Card.Img variant="top" style={{height:'190px' }} src={sImage} />
      <Card.Body>
        <Card.Title>{sTitle}</Card.Title>
        <Card.Text>
            {sBody}
          {/* Some quick example text to build on the card title and make up the
          bulk of the card's content. */}
        </Card.Text>
        {/* <Button variant="primary">Go somewhere</Button> */}
        <Link to={sLink}><Button variant="success">{sLinkLable}</Button></Link>
        
      </Card.Body>
    </Card>
  );
}

export default MenuOptions;